import { render, staticRenderFns } from "./FilterAgeSelect.vue?vue&type=template&id=a262852e"
import script from "./FilterAgeSelect.vue?vue&type=script&lang=js"
export * from "./FilterAgeSelect.vue?vue&type=script&lang=js"
import style0 from "./FilterAgeSelect.vue?vue&type=style&index=0&id=a262852e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports